<template>
  <list ref="list" :expired="true">
    <el-dropdown slot="column" slot-scope="{ data }">
      <el-link type="info" v-if="data.Surplus < 0 && data.State != 9 && data.State != -1">逾期终止</el-link>
      <el-link type="primary" v-else>{{ data.StateText }}<i class="el-icon-arrow-down" /></el-link>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-action="'/api/ProjectManage/Inquiry/SetReset'" @click.native="onReset(data)">重置/初始化</el-dropdown-item>
        <el-dropdown-item v-action="'/api/ProjectManage/Inquiry/Delete'" @click.native="onDelete(data)">作废</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </list>
</template>

<script>
export default {
  components: { list: () => import("./_list.vue") },
  methods: {
    onReset (row) {
      this.$confirm(row.Title, "重置询价单", {
        center: true
      }).then(() => {
        this.$apis.project.inquiry.reset({ id: row.Id }).then(() => {
          this.$message({ message: "初始化成功！", type: "success" })
          this.$refs.list.resetForm()
        }).catch((e) => {
          this.$message.error(e)
        })
      })
    },
    //删除
    onDelete (row) {
      this.$confirm(row.Title, '作废询价单', {
        center: true
      }).then(() => {
        this.$apis.project.inquiry.delete({ id: row.Id }).then(() => {
          this.$refs.list.loadData()
          this.$message({ message: "执行成功！", type: "success" })
        }).catch((e) => {
          this.$message.error(e)
        })
      })
    }
  }
}
</script>
